import type { OrderStatus } from '@restaurant/api-client';

/**
 * Single source of truth for order-status colours. Mirrors the shared status
 * palette the rest of the dashboard uses (see `getStatusColor` in
 * `utils/status.ts` for reservations):
 *
 *   orange = incoming / needs attention, blue = in flight,
 *   green = done, gray = closed / void.
 *
 * COMPLETED uses the app's success green (`#34c759` - the same token as the
 * reservation "Completed" summary and the workspace status chips), never the
 * darker action-button green. CANCELLED is neutral gray (`#8e8e93`), matching
 * how the shared reservation palette and `paymentPill` treat a void order: a
 * benign closed state, not a red payment failure. Import this map instead of
 * re-declaring status colours inline.
 */
export const orderStatusColor: Record<OrderStatus, string> = {
  PENDING: '#ff9500',
  CONFIRMED: '#007aff',
  COMPLETED: '#34c759',
  CANCELLED: '#8e8e93',
};
